import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/guzellik-merkezlerinin-dolgu-yapma-yetkisi-yasal-cerceve-ve-hasta-guvenligi/page.tsx");
